import { useState, type FormEvent } from 'react'
import { ApiError, api } from '../api'
import { vocabulary } from '../vocabulary'

const co = vocabulary.createOrg

/**
 * Shown once, right after a person's first sign-in, while they belong to no organization. Two
 * fields would be one too many: a name, and the button.
 *
 * Abandoning is safe by construction — nothing is written until the button is pressed, and
 * membership is what routes a person, so the next sign-in lands here again.
 */
export default function CreateOrganization({ onCreated }: { onCreated: () => void }) {
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent) {
    event.preventDefault()
    if (!name.trim() || busy) return
    setBusy(true)
    setError(null)
    try {
      await api.createOrganization(name.trim())
      onCreated()
    } catch (failure) {
      setError(failure instanceof ApiError ? failure.message : co.saveError)
      setBusy(false)
    }
  }

  return (
    <main className="center" style={{ padding: '48px 20px', flex: 1 }}>
      <form className="stack" style={{ gap: 18, width: '100%', maxWidth: 380 }} onSubmit={submit}>
        <div className="stack" style={{ gap: 6 }}>
          <h1 style={{ fontSize: 'var(--t-4)' }}>{co.title}</h1>
          <p className="small muted">
            {co.desc}
          </p>
        </div>

        {error && <p className="banner stop">{error}</p>}

        <label className="stack" style={{ gap: 6 }}>
          <span className="label">{co.nameLabel}</span>
          <input
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={co.namePlaceholder}
            maxLength={120}
            autoFocus
            required
          />
        </label>

        <button className="btn primary lg" type="submit" disabled={busy || !name.trim()}>
          {busy ? co.creating : co.createOrg}
        </button>

        <p className="tiny faint">
          {co.ownerNote}
        </p>
      </form>
    </main>
  )
}
